<div id="container" class="cls-container">
  <div id="bg-overlay" class="bg-img"></div>
  <div class="cls-content common-box">
    <div class="logo-paguela">
      <svg id="3761c0e9-7249-4cb5-bb79-46981908ee84" data-name="Logo Pague.la" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 340 84">
        <defs>
          <clipPath id="00368213-4fa7-4745-b1a1-8e72af7a814d">
            <path d="M279-73.24c3.41,0,4.48.87,4.48,3a12.4,12.4,0,0,1-1,5.15c-.87,1.47-2,1.87-5.08,1.87s-4.48-.6-4.48-3.07a15.07,15.07,0,0,1,.74-4.21C274.46-72.64,275.73-73.24,279-73.24Zm19.07-.47a20.56,20.56,0,0,0-.27,2.54c0,1.74.74,2.27,2.81,2.27h1.07c1.14,0,1.47.67,1.47,1.67,0,2.74-1.2,4.48-6.42,4.48s-7.55-1.94-7.55-6.15a18.91,18.91,0,0,1,.27-3.21l6-37.7c.27-1.87,2.47-2.61,4.41-2.61,1.74,0,4,.27,4,2a3.64,3.64,0,0,1-.07.74Zm27-10.56c2.07-.2,2.67-.47,3.14-3.21a9.46,9.46,0,0,0,.13-1.87c0-2.21-.94-3.88-5.62-3.88a38.54,38.54,0,0,0-8,.8c-1.34.33-2.14-.6-2.14-2.07a3.48,3.48,0,0,1,1.54-3.34c1.94-1.27,5.82-1.87,10.29-1.87,8.56,0,12.3,2.27,12.3,8.29,0,1-.13,2.14-.27,3.41l-3.34,20.72c-.54,3.48-5.61,4.48-13.9,4.48-9.36,0-12.5-2.34-12.5-8.09,0-3.88.94-7.69,3.34-9.76,1.94-1.74,5.08-2.54,9.49-3Zm1.6,7.89a3.5,3.5,0,0,0,.07-.8c0-1.54-.94-2.14-3.34-2.14h-3c-2.21,0-3.61.4-4.41,1.8a12.41,12.41,0,0,0-1.34,6.35c0,2.27,1.27,2.81,5.21,2.81,5,0,5.62-.33,6.22-4.48Zm-.37-30.19a2.82,2.82,0,0,1,.8-1.67L332-114.9c1-1.27,1.87-1.94,3.21-1.94,2.21,0,3.34,1.34,3.34,2.74a3.45,3.45,0,0,1-1.27,2.34l-5.79,5.39c-1.54,1.47-2.21,1.6-3.14,1.6A1.84,1.84,0,0,1,326.3-106.58ZM158.43-84.27c2.07-.2,2.67-.47,3.14-3.21a9.46,9.46,0,0,0,.13-1.87c0-2.21-.94-3.88-5.62-3.88a38.54,38.54,0,0,0-8,.8c-1.34.33-2.14-.6-2.14-2.07a3.48,3.48,0,0,1,1.54-3.34c1.94-1.27,5.82-1.87,10.29-1.87,8.56,0,12.3,2.27,12.3,8.29,0,1-.13,2.14-.27,3.41l-3.34,20.72c-.54,3.48-5.61,4.48-13.9,4.48-9.36,0-12.5-2.34-12.5-8.09,0-3.88.94-7.69,3.34-9.76,1.94-1.74,5.08-2.54,9.49-3Zm1.6,7.89a3.5,3.5,0,0,0,.07-.8c0-1.54-.94-2.14-3.34-2.14h-3c-2.21,0-3.61.4-4.41,1.8A12.41,12.41,0,0,0,148-71.17c0,2.27,1.27,2.81,5.21,2.81,5,0,5.62-.33,6.22-4.48ZM191-65c0-.8-.4-.93-1.81-.93-.93,0-2.27.27-4.88.27-7.82,0-11.3-2.41-11.3-9.63,0-5.95,1.81-15.91,6.48-20.52,2.94-2.94,7.15-3.94,13.44-3.94,8.42,0,11.43.6,11.43,3.28a5.72,5.72,0,0,1-.07,1l-4.75,29.74-.6,3.34c-2.14,10.29-9.63,11-17.85,11-5,0-10.23-.33-10.23-3.54,0-1.81.67-3.68,2.54-3.48a67.52,67.52,0,0,0,7.75.54c5.95,0,8.42-1,9.29-4.21A12.06,12.06,0,0,0,191-65Zm4-24.6c.07-.6.2-1.34.2-1.81,0-1.94-1.2-2.41-4.21-2.41a7.77,7.77,0,0,0-4.34.94c-3.34,2.47-5.08,11.56-5.08,16.71,0,3.61,1.34,4.88,5.08,4.88,4.48,0,5.55-1.34,6.22-5.41Zm39.18,21.86c-.4,2.61-.8,3.54-3,4a46.29,46.29,0,0,1-10.69,1.07c-10.43,0-13-3.41-13-8.76a25.94,25.94,0,0,1,.33-3.74L211.2-96.7c.33-2.07,2-2.61,4.48-2.61,2.07,0,3.94.34,3.94,2a4.75,4.75,0,0,1-.07.87l-3.21,20.05a26.08,26.08,0,0,0-.33,3.48c0,3.28,1.54,3.88,5.21,3.88,4.08,0,4.88-.27,5.21-2.54l3.94-25.13c.34-2.07,1.94-2.61,4.41-2.61,2.14,0,4,.34,4,2a4.85,4.85,0,0,1-.07.87Zm18.4-10.49C250-78,250-76.85,250-74.85c0,3.21.67,5.75,7,5.75a30.94,30.94,0,0,0,7.82-1.07,2.48,2.48,0,0,1,.67-.07c.87,0,1.67.6,1.67,2.07,0,4.75-4.28,5.55-11.5,5.55-9,0-13.9-3.21-13.9-11.9A57.05,57.05,0,0,1,243-84.61c2.27-11.43,7.69-15.1,16.44-15.1,8.42,0,12,3.28,12,10,0,7.89-3.08,10.56-11.43,11.1Zm-.13-11.43a15,15,0,0,0-1.14,5.15c0,.74.47,1.14,1.4,1.14h4.88c4.28,0,6.15-1.47,6.15-6.35,0-2.74-1-4.14-5.08-4.14C255.93-93.76,254-92.83,252.45-89.62Zm-137,24.13c-.34,2-2.21,2.67-4.81,2.67-1.81,0-3.88-.33-3.88-1.94a8.26,8.26,0,0,1,.13-1l7.27-41.41c.47-3.21,2.47-5.08,6.62-5.08h7.42c8.62,0,13.3,2.67,13.3,11.63,0,12.7-7.15,17.58-18.18,17.58H122c-2.47,0-3.21.74-3.41,2.14Zm4.93-26.84a14.62,14.62,0,0,0-.13,1.47c0,1.4.74,1.6,2.87,1.6,7.08,0,9.89-4.08,9.89-11.23,0-4.21-2.27-5.55-6.15-5.55s-4.14,0-4.68,3.07Zm-71.4-41.06c-25.58,0-35.5,4.71-41.75,21.47-3.67,9.95-5.75,25.66-5.75,33,0,12.26,4.82,18.65,14.18,21.68l12.16-53.82c.9-4.59,3.9-7.28,9.84-7.28H48.22c12.34,0,18.86,3.83,18.21,16.66-.92,18.18-11.51,25.17-27.3,25.17H37.31c-3.54,0-4.65,1.06-5,3.06L27.56-55.14c2.74.2,5.69.29,8.84.29,24,0,32.88-3.14,39.67-14.66,5.22-9.95,7.83-26.71,7.83-40.32C83.9-126.58,75.55-133.39,48.93-133.39Zm5.33,31.9c.3-6-2.85-7.94-8.4-7.94s-5.93,0-6.92,4.39L35.59-89.81a21.15,21.15,0,0,0-.29,2.1c-.1,2,.94,2.3,4,2.3C49.43-85.4,53.75-91.24,54.27-101.48Z" style="fill:none" />
          </clipPath>
          <radialGradient id="681b0aef-dee0-4a8a-88ab-a76a805598ff" cx="431.43" cy="272.14" fx="461.40104484922847" fy="235.09323886001638" r="278.53" gradientTransform="translate(-678.83 -234.73) scale(1.73 0.88)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#00f6ff" />
            <stop offset="0.07" stop-color="#20c7ff" />
            <stop offset="0.16" stop-color="#4099ff" />
            <stop offset="0.25" stop-color="#5c70ff" />
            <stop offset="0.34" stop-color="#744dff" />
            <stop offset="0.44" stop-color="#8731ff" />
            <stop offset="0.55" stop-color="#961bff" />
            <stop offset="0.67" stop-color="#a10cff" />
            <stop offset="0.8" stop-color="#a703ff" />
            <stop offset="1" stop-color="#a900ff" />
          </radialGradient>
        </defs>
        <title>Pague.la</title>
        <g style="clip-path:url(#00368213-4fa7-4745-b1a1-8e72af7a814d)">
          <rect x="-63.1" y="-185.99" width="455.93" height="231.36" style="fill:url(#681b0aef-dee0-4a8a-88ab-a76a805598ff)" />
        </g>
        <path d="M279,61.14c3.41,0,4.48.87,4.48,3a12.4,12.4,0,0,1-1,5.15c-.87,1.47-2,1.87-5.08,1.87s-4.48-.6-4.48-3.07a15.07,15.07,0,0,1,.74-4.21C274.46,61.75,275.73,61.14,279,61.14Zm19.07-.47a20.56,20.56,0,0,0-.27,2.54c0,1.74.74,2.27,2.81,2.27h1.07c1.14,0,1.47.67,1.47,1.67,0,2.74-1.2,4.48-6.42,4.48s-7.55-1.94-7.55-6.15a18.91,18.91,0,0,1,.27-3.21l6-37.7c.27-1.87,2.47-2.61,4.41-2.61,1.74,0,4,.27,4,2a3.64,3.64,0,0,1-.07.74Zm27-10.56c2.07-.2,2.67-.47,3.14-3.21a9.46,9.46,0,0,0,.13-1.87c0-2.21-.94-3.88-5.62-3.88a38.54,38.54,0,0,0-8,.8c-1.34.33-2.14-.6-2.14-2.07a3.48,3.48,0,0,1,1.54-3.34c1.94-1.27,5.82-1.87,10.29-1.87,8.56,0,12.3,2.27,12.3,8.29,0,1-.13,2.14-.27,3.41l-3.34,20.72c-.54,3.48-5.61,4.48-13.9,4.48-9.36,0-12.5-2.34-12.5-8.09,0-3.88.94-7.69,3.34-9.76,1.94-1.74,5.08-2.54,9.49-3Zm1.6,7.89a3.5,3.5,0,0,0,.07-.8c0-1.54-.94-2.14-3.34-2.14h-3c-2.21,0-3.61.4-4.41,1.8a12.41,12.41,0,0,0-1.34,6.35c0,2.27,1.27,2.81,5.21,2.81,5,0,5.62-.33,6.22-4.48Zm-.37-30.19a2.82,2.82,0,0,1,.8-1.67L332,19.48c1-1.27,1.87-1.94,3.21-1.94,2.21,0,3.34,1.34,3.34,2.74a3.45,3.45,0,0,1-1.27,2.34L331.52,28c-1.54,1.47-2.21,1.6-3.14,1.6A1.84,1.84,0,0,1,326.3,27.81ZM158.43,50.12c2.07-.2,2.67-.47,3.14-3.21A9.46,9.46,0,0,0,161.7,45c0-2.21-.94-3.88-5.62-3.88a38.54,38.54,0,0,0-8,.8c-1.34.33-2.14-.6-2.14-2.07a3.48,3.48,0,0,1,1.54-3.34c1.94-1.27,5.82-1.87,10.29-1.87,8.56,0,12.3,2.27,12.3,8.29,0,1-.13,2.14-.27,3.41l-3.34,20.72c-.54,3.48-5.61,4.48-13.9,4.48-9.36,0-12.5-2.34-12.5-8.09,0-3.88.94-7.69,3.34-9.76,1.94-1.74,5.08-2.54,9.49-3ZM160,58a3.5,3.5,0,0,0,.07-.8c0-1.54-.94-2.14-3.34-2.14h-3c-2.21,0-3.61.4-4.41,1.8A12.41,12.41,0,0,0,148,63.22c0,2.27,1.27,2.81,5.21,2.81,5,0,5.62-.33,6.22-4.48Zm31,11.43c0-.8-.4-.93-1.81-.93-.93,0-2.27.27-4.88.27-7.82,0-11.3-2.41-11.3-9.63,0-5.95,1.81-15.91,6.48-20.52,2.94-2.94,7.15-3.94,13.44-3.94,8.42,0,11.43.6,11.43,3.28a5.72,5.72,0,0,1-.07,1L199.55,68.7,199,72c-2.14,10.29-9.63,11-17.85,11-5,0-10.23-.33-10.23-3.54,0-1.81.67-3.68,2.54-3.48a67.52,67.52,0,0,0,7.75.54c5.95,0,8.42-1,9.29-4.21A12.06,12.06,0,0,0,191,69.43Zm4-24.6c.07-.6.2-1.34.2-1.81,0-1.94-1.2-2.41-4.21-2.41a7.77,7.77,0,0,0-4.34.94c-3.34,2.47-5.08,11.56-5.08,16.71,0,3.61,1.34,4.88,5.08,4.88,4.48,0,5.55-1.34,6.22-5.41Zm39.18,21.86c-.4,2.61-.8,3.54-3,4a46.29,46.29,0,0,1-10.69,1.07c-10.43,0-13-3.41-13-8.76a25.94,25.94,0,0,1,.33-3.74l3.34-21.59c.33-2.07,2-2.61,4.48-2.61,2.07,0,3.94.34,3.94,2a4.75,4.75,0,0,1-.07.87L216.34,58a26.08,26.08,0,0,0-.33,3.48c0,3.28,1.54,3.88,5.21,3.88,4.08,0,4.88-.27,5.21-2.54l3.94-25.13c.34-2.07,1.94-2.61,4.41-2.61,2.14,0,4,.34,4,2a4.85,4.85,0,0,1-.07.87Zm18.4-10.49c-2.54.2-2.54,1.34-2.54,3.34,0,3.21.67,5.75,7,5.75a30.94,30.94,0,0,0,7.82-1.07,2.48,2.48,0,0,1,.67-.07c.87,0,1.67.6,1.67,2.07,0,4.75-4.28,5.55-11.5,5.55-9,0-13.9-3.21-13.9-11.9A57.05,57.05,0,0,1,243,49.78c2.27-11.43,7.69-15.1,16.44-15.1,8.42,0,12,3.28,12,10,0,7.89-3.08,10.56-11.43,11.1Zm-.13-11.43a15,15,0,0,0-1.14,5.15c0,.74.47,1.14,1.4,1.14h4.88c4.28,0,6.15-1.47,6.15-6.35,0-2.74-1-4.14-5.08-4.14C255.93,40.62,254,41.56,252.45,44.77Zm-137,24.13c-.34,2-2.21,2.67-4.81,2.67-1.81,0-3.88-.33-3.88-1.94a8.26,8.26,0,0,1,.13-1l7.27-41.41c.47-3.21,2.47-5.08,6.62-5.08h7.42c8.62,0,13.3,2.67,13.3,11.63,0,12.7-7.15,17.58-18.18,17.58H122c-2.47,0-3.21.74-3.41,2.14Zm4.93-26.84a14.62,14.62,0,0,0-.13,1.47c0,1.4.74,1.6,2.87,1.6,7.08,0,9.89-4.08,9.89-11.23,0-4.21-2.27-5.55-6.15-5.55s-4.14,0-4.68,3.07ZM48.93,1C23.35,1,13.44,5.71,7.18,22.47c-3.67,9.95-5.75,25.66-5.75,33,0,12.26,4.82,18.65,14.18,21.68L27.76,23.33c.9-4.59,3.9-7.28,9.84-7.28H48.22c12.34,0,18.86,3.83,18.21,16.66-.92,18.18-11.51,25.17-27.3,25.17H37.31c-3.54,0-4.65,1.06-5,3.06L27.56,79.25c2.74.2,5.69.29,8.84.29,24,0,32.88-3.14,39.67-14.66,5.22-9.95,7.83-26.71,7.83-40.32C83.9,7.81,75.55,1,48.93,1Zm5.33,31.9c.3-6-2.85-7.94-8.4-7.94s-5.93,0-6.92,4.39L35.59,44.58a21.15,21.15,0,0,0-.29,2.1c-.1,2,.94,2.3,4,2.3C49.43,49,53.75,43.15,54.27,32.9Z" style="fill:#fff" />
      </svg>
    </div>
    <div class="cls-content-lg panel">
      <div class="panel-body secoes">
        <div id="icone-top" class="icone mb-40">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 70 70" width="63" alt="Login Pague.lá" class="objeto-icone icone-avatar">
            <defs>
              <linearGradient id="a" x1="22.77" y1="70.33" x2="42.88" y2="46.89" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#4379ff" />
                <stop offset="1" stop-color="#8e42ff" />
              </linearGradient>
              <linearGradient id="b" x1="24.85" y1="42.49" x2="43.6" y2="20.64" xlink:href="#a" />
              <linearGradient id="c" x1="4" y1="35" x2="66" y2="35" xlink:href="#a" />
            </defs>
            <title>ilustra-login</title>
            <path class="path-1" d="M11.6,59.43a36.07,36.07,0,0,1,42.45-1.64" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="url(#a)" />
            <circle class="path-2" cx="34.23" cy="31.57" r="13.4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="url(#b)" />
            <path class="path-3" d="M63.4,15.09c-2.82-6-9.88-8.57-23.84-8.57C21,6.52,13.72,9.93,9.18,22.08,6.51,29.3,5,40.68,5,46c0,14,8.72,17.46,25.44,17.46,17.47,0,23.94-2.27,28.86-10.64C61.83,48,63.54,41,64.37,33.93A90.34,90.34,0,0,0,65,23.61,19.41,19.41,0,0,0,63.4,15.09Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px" stroke="url(#c)" />
          </svg>
        </div>

        <h3 *ngIf="notFoundAccount" class="mb-40" animate="fadeIn" delay="100">
          Conta não encontrada.
        </h3>

        <div class="secao secao-1 dados-cadastrais" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Complete o seu cadastro na <span class="text-primary">Pague.lá</span>!
          </h3>

          <div class="tipo-de-pessoa">
            <button (click)="changeTipoPessoa('Fisica')" [ngClass]="tipoPessoa === 'Fisica' ? 'active' : ''">Física</button>
            <button (click)="changeTipoPessoa('Juridica')" [ngClass]="tipoPessoa === 'Juridica' ? 'active' : ''">Jurídica</button>
          </div>

          <form [hidden]="tipoPessoa === 'Juridica'">
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">CPF</label>
                  <input id="inputCpf" class="form-control" type="text" name="Cpf" mask="000.000.000-00" [(ngModel)]="conta.CpfCnpj" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-InputCpf" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Primeiro Nome</label>
                  <input id="inputNome" class="form-control" type="text" name="Nome" [(ngModel)]="conta.Nome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNome" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Sobrenome</label>
                  <input id="inputSobrenome" class="form-control" type="text" name="Sobrenome" [(ngModel)]="conta.Sobrenome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputSobrenome" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Nome Fantasia</label>
                  <input id="inputNomeFantasia" class="form-control" type="text" name="Fantasia" [(ngModel)]="conta.Fantasia" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNomeFantasia" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>

          <form [hidden]="tipoPessoa === 'Fisica'">
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">CNPJ</label>
                  <input id="inputCnpj" class="form-control" type="text" name="Cnpj" mask="00.000.000/0000-00" [(ngModel)]="conta.CpfCnpj" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputCnpj" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Razão social</label>
                  <input id="inputRazaoSocial" class="form-control" type="text" name="RazaoSocial" [(ngModel)]="conta.RazaoSocial" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputRazaoSocial" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Nome Fantasia</label>
                  <input id="inputFantasia" class="form-control" type="text" name="Fantasia" [(ngModel)]="conta.Fantasia" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputFantasia" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Nome do Responsável</label>
                  <input id="inputNomeResponsavel" class="form-control" type="text" name="Nome" [(ngModel)]="conta.Nome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNomeResponsavel" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Sobrenome do Responsável</label>
                  <input id="inputSobrenomeResponsavel" class="form-control" type="text" name="Sobrenome" [(ngModel)]="conta.Sobrenome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputSobrenomeResponsavel" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-2" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Seus dados de <span class="text-primary">contato</span>
          </h3>

          <form>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">CEP</label>
                  <input id="inputCep" class="form-control" type="text" name="Cep" [(ngModel)]="endereco.Cep" mask="00000-000" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputCep" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Logradouro</label>
                  <input id="inputLogradouro" class="form-control" type="text" name="Logradouro" [(ngModel)]="endereco.Logradouro" (keyup)="cleanErrorClass($event)">
                  <a id="link-inputLogradouro" style="display: none;" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-6 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Complemento</label>
                  <input id="inputComplemento" class="form-control" type="text" name="Complemento" [(ngModel)]="endereco.Complemento" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputComplemento" class="input-link">Alterar</a>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Número</label>
                  <input id="inputNumero" class="form-control" type="text" name="Numero" [(ngModel)]="endereco.Numero" (keyup)="cleanErrorClass($event)" mask="000000">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNumero" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Bairro</label>
                  <input id="inputBairro" class="form-control" type="text" name="Bairro" [(ngModel)]="endereco.Bairro" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputBairro" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-3 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Estado</label>
                  <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownEstado" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ endereco.Estado || 'UF' }}<span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li (click)="selectUf(uf)" *ngFor="let uf of ufs"><a>{{ uf }}</a></li>
                    </ul>
                  </div>
                  <a (click)="editInput($event)" id="link-inputEstado" style="display: none;" class="input-link">Alterar</a>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Cidade</label>
                  <input id="inputCidade" class="form-control" type="text" name="Cidade" [(ngModel)]="endereco.Cidade" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputCidade" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Telefone</label>
                  <input id="inputTelefone" class="form-control" mask="(00) 00000-0000" type="text" name="Telefone" [(ngModel)]="conta.Telefone" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputTelefone" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-3 informacoes-bancarias" style="display: none;">
          <h3 animate="fadeIn" delay="100">
            Seus dados <span class="text-primary">bancários</span>
          </h3>
          <h4 class="mb-40" animate="fadeIn" delay="100" style="font-weight: 200;">
            A conta em que você irá receber seus pagamentos.<br>Deve ser de mesma titularidade do cadastro.
          </h4>

          <form>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Banco</label>
                  <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenuBanco" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ banco.name || 'Selecione' }}<span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li (click)="selectBanco(banco)" *ngFor="let banco of bancos"><a>{{ banco.name }}</a></li>
                    </ul>
                  </div>
                  <a (click)="editInput($event)" style="display: none;" id="link-inputBanco" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-6 col-sm-offset-2">
                  <div class="form-group" animate="fadeIn" delay="300">
                    <label for="" class="control-label">Tipo de Conta</label>
                    <div class="dropdown">
                      <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenuTipoConta" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ tipoConta.name || 'Selecione' }}<span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu">
                        <li (click)="selectTipoConta(tipoConta)" *ngFor="let tipoConta of tiposConta"><a>{{ tipoConta.name }}</a></li>
                      </ul>
                    </div>
                    <a (click)="editInput($event)" style="display: none;" id="link-inputBanco" class="input-link">Alterar</a>
                  </div>
                </div>
              <div class="col-sm-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Agência</label>
                  <input id="inputAgencia" class="form-control" type="text" name="Agencia" [(ngModel)]="informacaoBancaria.Agencia" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputAgenciaDigito" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-6 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Conta Corrente</label>
                  <input id="inputConta" class="form-control" type="text" name="Conta" [(ngModel)]="informacaoBancaria.NumeroConta" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputConta" class="input-link">Alterar</a>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Dígito</label>
                  <input id="inputDigito" class="form-control" type="text" name="Conta" [(ngModel)]="informacaoBancaria.ContaDigito" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputDigito" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-4 documentos" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Envie seus <span class="text-primary">documentos</span>
          </h3>

          <form *ngIf="tipoPessoa === 'Fisica'">
            <div class="row text-left">
              <div class="col-xs-7 col-xs-offset-2">
                <div class="form-group">
                  <label class="control-label">Identificação</label>
                  <label [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''" class="input" for="arquivo-identificacao">{{ fileNames.identificacao || 'Selecionar arquivo...' }}</label>
                  <input [disabled]="!filesEmpty.identificacao ? true : false" (change)="selectFile($event)" class="file" id="arquivo-identificacao" name="file" type="file">
                </div>
              </div>
              <div class="col-xs-1">
                <div class="icon-camera">
                  <i *ngIf="!filesEmpty.identificacao" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                  <i *ngIf="filesEmpty.identificacao" (click)="openWebcamModal('identificacao')" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                </div>
              </div>
              <div class="col-xs-7 col-xs-offset-2">
                <div class="form-group">
                  <label class="control-label">Atividade</label>
                  <label [ngClass]="!filesEmpty.atividade ? 'disabled' : ''" class="input" for="arquivo-atividade">{{ fileNames.atividade || 'Selecionar arquivo...' }}</label>
                  <input [disabled]="!filesEmpty.atividade ? true : false" (change)="selectFile($event)" class="file" id="arquivo-atividade" name="file" type="file">
                </div>
              </div>
              <div class="col-xs-1">
                <div class="icon-camera">
                  <i *ngIf="!filesEmpty.atividade" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                  <i *ngIf="filesEmpty.atividade" (click)="openWebcamModal('atividade')" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                </div>
              </div>
              <div class="col-xs-7 col-xs-offset-2">
                <div class="form-group mb-40">
                  <label class="control-label">Residência</label>
                  <label [ngClass]="!filesEmpty.residencia ? 'disabled' : ''" class="input" for="arquivo-residencia">{{ fileNames.residencia || 'Selecionar arquivo...' }}</label>
                  <input [disabled]="!filesEmpty.residencia ? true : false" (change)="selectFile($event)" class="file" id="arquivo-residencia" name="file" type="file">
                </div>
              </div>
              <div class="col-xs-1">
                <div class="icon-camera">
                  <i *ngIf="!filesEmpty.residencia" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                  <i *ngIf="filesEmpty.residencia" (click)="openWebcamModal('residencia')" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                </div>
              </div>
            </div>
          </form>

          <form *ngIf="tipoPessoa === 'Juridica'">
              <div class="row text-left">
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group">
                    <label class="control-label">Identificação</label>
                    <label [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''" class="input" for="arquivo-identificacao">{{ fileNames.identificacao || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.identificacao ? true : false" (change)="selectFile($event)" class="file" id="arquivo-identificacao" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.identificacao" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.identificacao" (click)="openWebcamModal('identificacao')" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                  </div>
                </div>
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group">
                    <label class="control-label">Atividade</label>
                    <label [ngClass]="!filesEmpty.atividade ? 'disabled' : ''" class="input" for="arquivo-atividade">{{ fileNames.atividade || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.atividade ? true : false" (change)="selectFile($event)" class="file" id="arquivo-atividade" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.atividade" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.atividade" (click)="openWebcamModal('atividade')" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                  </div>
                </div>
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group">
                    <label class="control-label">Residência</label>
                    <label [ngClass]="!filesEmpty.residencia ? 'disabled' : ''" class="input" for="arquivo-residencia">{{ fileNames.residencia || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.residencia ? true : false" (change)="selectFile($event)" class="file" id="arquivo-residencia" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.residencia" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.residencia" (click)="openWebcamModal('residencia')" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                  </div>
                </div>
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group mb-40">
                    <label class="control-label">CNPJ</label>
                    <label [ngClass]="!filesEmpty.cnpj ? 'disabled' : ''" class="input" for="arquivo-cnpj">{{ fileNames.cnpj || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.cnpj ? true : false" (change)="selectFile($event)" class="file" id="arquivo-cnpj" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.cnpj" class="fa fa-camera" [ngClass]="!filesEmpty.cnpj ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.cnpj" (click)="openWebcamModal('cnpj')" class="fa fa-camera" [ngClass]="!filesEmpty.cnpj ? 'disabled' : ''"></i>
                  </div>
                </div>
              </div>
            </form>
        </div>

        <div class="secao secao-5 informacoes-cartao" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Conclua seu <span class="text-primary">pagamento</span>
          </h3>
          <div class="text-implantacao">
            <span class="text-primary">Implantação __________________ R$ 390,00</span>
          </div>
          <form autocomplete="off" class="panel-body2 ng-untouched ng-pristine ng-valid" id="form-checkout" *ngIf="formCartao">
            <div class="row mt-10">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group has-feedback text-left">
                  <label class="control-label" for="cartao">Nº Cartão de Crédito</label>
                  <div class="form-group has-feedback text-left">
                    <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control cartao-credito" mask="0000 0000 0000 0000" placeholder="XXXX XXXX XXXX XXXX" type="text" (bandeira)="setBrand($event)" [(ngModel)]="card.Numero" name="cartao" id="cartao" appBandeiraCartao>
                    <figure class="bandeira-cartao default form-control-feedback"></figure>
                  </div>
                  <figure class="bandeira-cartao default form-control-feedback"></figure>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 col-sm-offset-2">
                <div class="form-group text-left">
                  <label class="control-label" for="validademes">Validade</label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" mask="00" maxlength="2" placeholder="mês" type="text" [(ngModel)]="validadeMesCartao" id="validademes" name="validademes">
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group text-left">
                  <label class="control-label" for="validadeano">&nbsp;</label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" mask="00" maxlength="2" placeholder="ano" type="text" [(ngModel)]="validadeAnoCartao" id="validadeano" name="validadeano">
                </div>
              </div>
              <div class="col-sm-3 col-sm-offset-1">
                <div class="form-group text-left">
                  <label class="control-label" for="codseguranca">Cód. Segurança</label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" mask="000" maxlength="3" placeholder="XXX" type="text" [(ngModel)]="card.CodigoSeguranca" id="codseguranca" name="codseguranca">
                </div>
              </div>
            </div>
            <div class="row mb-40">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group text-left">
                  <label class="control-label" for="nometitular">Nome do Titular
                    <small> (como escrito no cartão)</small>
                  </label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" maxlength="50" placeholder="Nome Sobrenome" type="text" [(ngModel)]="card.NomeComprador" id="nometitular" name="nometitular">
                </div>
              </div>
            </div>
          </form>

          <div *ngIf="success" id="resultado-sucesso" class="panel-body2 mb-40 col-sm-offset-2 col-sm-8">
            <div class="mensagem-sucesso">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
                <title>Aprovada!</title>
                <g id="41c310f0-3cde-4914-9ee4-e4952dc4cf98" data-name="Círculo Aprovado">
                  <circle cx="35" cy="35" r="25" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                  />
                </g>
                <g id="752bc498-d218-4c7d-b07b-03fcc9fc5d57" data-name="Ok Aprovado">
                  <polyline points="21.74 29.96 33.7 41.88 68.21 15.36" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                  />
                </g>
              </svg>
              <h3>{{msgSuccess}}</h3>
            </div>
            <div class="info-transacao-aprovada">
              <div class="dados-aprovados">
                <span>
                  Cartão
                </span>
                <span class="text-bold info-cartao">
                  <span id="numero-cartao">XXXX XXXX XXXX {{card.Numero.length === 4 ? card.Numero : getLastDigits(card.Numero)}}</span>
                  <figure [ngClass]="'bandeira-cartao ' + getClassBandeiraCartao(card.Bandeira)"></figure>
                </span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  Validade
                </span>
                <span id="validade-cartao" class="text-bold">{{validadeMesCartao + '/20' + validadeAnoCartao}}</span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  Titular
                </span>
                <span id="titular-cartao" class="text-bold">{{card.NomeComprador}}</span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  Comprovante (Tid)
                </span>
                <span id="numero-comprovante" class="text-bold">{{transaction.Transacao.Tid}}</span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  <b>Valor</b>
                </span>
                <span id="valor" class="text-bold">{{transaction.Transacao.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="error" class="panel-body2 mb-40" id="resultado-reprovado">
            <div class="resultado-reprovado">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
                <title>Transação Reprovada</title>
                <g id="f32c9904-9a49-4b84-a96b-1205778d7e8e" data-name="Camada 2">
                  <circle cx="35" cy="35" r="25" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" />
                </g>
                <g id="5db0cdd3-dede-4fdb-87f7-b5ef7f2d2bf1" data-name="Camada 3">
                  <line x1="24.39" y1="24.39" x2="45.61" y2="45.61" class="linha-2" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" />
                </g>
                <g id="fb91e5a3-f581-43de-b27f-420a0e4d440d" data-name="Camada 4">
                  <line x1="45.61" y1="24.39" x2="24.39" y2="45.61" class="linha-1" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" />
                </g>
              </svg>
              <h3 id="erro-principal" class="text-danger"></h3>
            </div>
            <div class="erro-reprovacao">
              <span id="msg-erro" class="text-bold">{{ msgError }}</span>
            </div>
          </div>
        </div>

        <div class="secao secao-6 criar-senha" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
              Crie a sua <span class="text-primary">senha</span> de acesso
          </h3>

          <form>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Senha</label>
                  <input id="inputSenha" class="form-control" type="password" name="Senha" [(ngModel)]="senha" autocomplete="off" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputSenha" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Confirme a Senha</label>
                  <input id="inputConfirmaSenha" class="form-control" type="password" name="ConfirmarSenha" [(ngModel)]="confirmaSenha" autocomplete="off" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputConfirmaSenha" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="checkbox">
              <div>
                <input (change)="removeWarning()" id="check-termos" type="checkbox" class="styled-checkbox">
                <label for="check-termos">
                  <svg id="svg-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title></title><polyline points="4 8 7 11 12 6" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></polyline></svg>
                </label>
                <span>Li e aceito os <a (click)="openModal()">Termos de Serviço</a></span>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-7 finished" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Seu cadastro foi finalizado e enviado para análise! Entraremos em contato em até 1 dia útil com a confirmação!
          </h3>
          <div class="icone-sucesso">
            <div class="icone">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 70 70" width="175" class=""><defs><linearGradient id="a" x1="17" y1="33.82" x2="69" y2="33.82" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4379ff"/><stop offset="1" stop-color="#8e42ff"/></linearGradient><linearGradient id="b" x1="6.5" y1="35" x2="63.5" y2="35" xlink:href="#a"/></defs><title>ilustra-check</title><path class="path-1" d="M18 35.47 29 46.17 68 21.47" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="url(#a)"/><path class="path-2" d="M61,16.75C58.45,11.26,52,8.89,39.18,8.89c-17,0-23.69,3.13-27.85,14.27C8.88,29.77,7.5,40.21,7.5,45.1c0,12.88,8,16,23.32,16,16,0,21.94-2.09,26.45-9.76,2.32-4.41,3.89-10.86,4.65-17.33a81.89,81.89,0,0,0,.58-9.46A17.92,17.92,0,0,0,61,16.75Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="url(#b)"/></svg>
            </div>
          </div>
        </div>

        <div class="row btns">
          <div class="col-sm-4 mb-30 btn-back" animate="fadeIn" delay="900" style="opacity: 0;">
            <button (click)="previousSection()" class="btn btn-invertido" type="submit">Voltar</button>
          </div>
          <div class="mb-30 btn-next" animate="fadeIn" delay="900">
            <button [ngClass]="isOutline ? 'btn-outline btn btn-primary btn-registrar' : 'btn btn-primary btn-registrar'" (click)="nextSection()" type="submit">Avançar</button>
          </div>
        </div>

        <div class="navegacao mb-40" *ngIf="!isFinished">
          <div class="ponto" (click)="changePage($event)" *ngFor="let section of sections; index as i" [attr.data-index]="section" [ngClass]="i === 0 ? 'ativo' : ''"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-detail-doc class="modal-info" [showModal]="showModal" (click)="openModal()" (eventClose)="closeModal()">
  <iframe src="/assets/docs/termos.pdf"></iframe>
</app-modal-detail-doc>

<app-modal-detail-doc class="modal-info" [showModal]="showWebcamModal" (eventClose)="closeWebcamModal()">
  <div *ngIf="showWebcamModal" class="webcam" (resize)="onResize($event)">
      <webcam [allowCameraSwitch]="false" [hidden]="webcamImage" [width]="width" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"></webcam>

      <img [hidden]="!webcamImage" [src]="webcamImage">

      <button *ngIf="!webcamImage" (click)="snapshot()" class="btn btn-primary btn-webcam"><i class="fa fa-camera"></i></button>

      <button *ngIf="webcamImage" (click)="accept()" class="btn btn-primary btn-webcam accept"><i class="fa fa-check"></i></button>
      <button *ngIf="webcamImage" (click)="cancel()" class="btn btn-primary btn-webcam cancel"><i class="fa fa-close"></i></button>
  </div>
</app-modal-detail-doc>
